import { WhatsupIconColor } from '../messengers/WhatsupIconColor';

export interface IColorIcon {
    isActive: boolean;
}
export const WatsupIcon = () => {
    return <WhatsupIconColor />;
};
